import { isBefore, isDayInPast } from '..';

/**
 * Check if given date is in the past
 */
export default function isInPast(dt, options) {
  if (options?.onlyDay) return isDayInPast(dt);
  return isBefore(dt, new Date());
}
